/* eslint-disable */
import React, { useEffect, useState } from 'react'
import { EditPageHeader } from '../../components/EditPageHeader';
import * as API from "../../framework/API/api"
import { ENTITYNAME, LOGEVENT, MODULE, OPERATING_SYSTEM, OTT_POSTER_TYPE, PAYMENT_TYPE, TOAST_TYPES } from "../../framework/constant/constant";
import { useTranslation } from '../../locale/useTranslation';
import { utility } from '../../framework/utility/utilityProvider';
import { ImageBrowser } from '../../framework/forms/helpercomponents/selectFile/ImageBrowser';
import BossDialog from '../../components/BossDialog';
import MyMultiSelect from '../../components/MyMultiSelect';
import { Switch } from '@mui/material';
import { DropDownList } from '@progress/kendo-react-dropdowns';
import ToastNotification from "../../components/ToastNotification";

const PaymentProviderEditForm = (props) => {

    const lang = useTranslation();

    const blankDataItem = {
        ...props.item,
        Name: props?.item?.SID
            ? { SID: props.item.SID, Description: props.item.copy ? "Copy of " + utility.getKeyByValue(PAYMENT_TYPE, props.item.SID) : utility.getKeyByValue(PAYMENT_TYPE, props.item.SID) } : {},
        locale: props.item.locale ?? "",
        liveKeyID: props.item.liveKeyID ?? "",
        liveSecretKey: props.item.liveSecretKey ?? "",
        sandboxKeyID: props.item.sandboxKeyID ?? "",
        sandboxSecretKey: props.item.sandboxSecretKey ?? "",
        currencyCode: props.item.currencyCode ?? "",
        brandingName: props.item.brandingName ?? "",
        brandingLogo: props.item.brandingLogo ?? "",
        brandingColor: props.item.brandingColor ?? "#000000",
        successUrl: props.item.successUrl ?? "",
        failureUrl: props.item.failureUrl ?? "",
        paymentGatewayUrl: props.item.paymentGatewayUrl ?? "",
        message: props.item.message ?? "",
        Archive: props.item.Archive ?? false,
        isActive: props.item.isActive ?? false,
        isSandboxMode: props?.item?.isSandboxMode ?? false,
        countryCode: props.item.countryCode ?? "",
        OS: props.item.OS && props.item.OS.length > 0
            ? props.item.OS.map(id => {
                const description = Object.keys(OPERATING_SYSTEM).find(
                    key => OPERATING_SYSTEM[key] === id
                );
                return { _id: id, Description: description };
            })
            : []
    }

    const [dataItem, setDataItem] = useState(blankDataItem);
    const [imageFiles, setImageFiles] = useState(new Set());
    const [os, setOs] = useState([]);
    const [paymentTypes, setPaymentTypes] = useState([]);

    useEffect(() => {
        loadcombo();
    }, []);

    const loadcombo = async () => {
        const osRes = Object.keys(OPERATING_SYSTEM).map(key => ({
            _id: OPERATING_SYSTEM[key],
            Description: key
        }));
        setOs(osRes);
        const paymentTypeRes = Object.keys(PAYMENT_TYPE).map(key => ({
            SID: PAYMENT_TYPE[key],
            Description: key
        }));
        setPaymentTypes(paymentTypeRes);
    };


    const onChange = (e) => {
        const { name, type, value, files } = e.target;

        if (name == 'brandingLogo' && e.target?.files) {
            if (type === 'file' && files?.length > 0) {
                setImageFiles(files[0]);
                setDataItem({ ...dataItem, brandingLogo: files[0] ? URL.createObjectURL(files[0]) : "" });
            } else {
                setImageFiles(new Set());
                setDataItem({ ...dataItem, brandingLogo: "" });
            }
        }
        else if (name === 'Archive') {
            setDataItem({ ...dataItem, Archive: !dataItem.Archive });
        } else if (name === 'isActive') {
            setDataItem({ ...dataItem, isActive: !dataItem.isActive });
        } else if (name === 'isSandboxMode') {
            setDataItem({ ...dataItem, isSandboxMode: !dataItem.isSandboxMode });
        } else {
            setDataItem({ ...dataItem, [name]: value });
        }
    };

    const isValid = () => {
        const selectedSID = dataItem?.Name?.SID;

        if (!selectedSID) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_name_error_message });
            return false;
        }

        if (selectedSID === PAYMENT_TYPE.AppleSubscription) {
            if (!dataItem.OS || dataItem.OS.length == 0) {
                ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_os_error_message });
                return false;
            }
            if (dataItem.brandingName == undefined || dataItem.brandingName == "") {
                ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_enter_branding_name_error_message });
                return false;
            }
            if ((!imageFiles || imageFiles === null) && (!dataItem.brandingLogo || dataItem.brandingLogo === "")) {
                ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_enter_branding_logo_error_message });
                return false;
            }
            return true;
        }

        if (dataItem.isSandboxMode === true) {
            if (!dataItem.sandboxKeyID) {
                ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_enter_key_id_error_message });
                return false;
            }

            if (!dataItem.sandboxSecretKey) {
                ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_enter_secret_key_error_message });
                return false;
            }
        }

        if (!dataItem.OS || dataItem.OS.length == 0) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_os_error_message });
            return false;
        }

        switch (selectedSID) {
            case PAYMENT_TYPE.PayPal:
            case PAYMENT_TYPE.Gpay:
                if (dataItem.liveKeyID == undefined || dataItem.liveKeyID == "") {
                    ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_enter_live_key_id_error_message });
                    return false;
                }
                if (dataItem.liveSecretKey == undefined || dataItem.liveSecretKey == "") {
                    ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_enter_live_secret_key_error_message });
                    return false;
                }
                if (dataItem.brandingName == undefined || dataItem.brandingName == "") {
                    ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_enter_branding_name_error_message });
                    return false;
                }
                if (dataItem.currencyCode == undefined || dataItem.currencyCode == "") {
                    ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_enter_currency_code_error_message });
                    return false;
                }
                if (dataItem.countryCode == undefined || dataItem.countryCode == "") {
                    ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_enter_country_code_error_message });
                    return false;
                }
                if (dataItem.paymentGatewayUrl == undefined || dataItem.paymentGatewayUrl == "") {
                    ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_enter_payment_gateway_url_error_message });
                    return false;
                }
                if (dataItem.successUrl == undefined || dataItem.successUrl == "") {
                    ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_enter_success_url_error_message });
                    return false;
                }
                if (dataItem.failureUrl == undefined || dataItem.failureUrl == "") {
                    ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_enter_failure_url_error_message });
                    return false;
                }
                break;

            case PAYMENT_TYPE.Stripe:
                if (dataItem.liveKeyID == undefined || dataItem.liveKeyID == "") {
                    ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_enter_live_key_id_error_message });
                    return false;
                }
                if (dataItem.liveSecretKey == undefined || dataItem.liveSecretKey == "") {
                    ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_enter_live_secret_key_error_message });
                    return false;
                }
                if (dataItem.currencyCode == undefined || dataItem.currencyCode == "") {
                    ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_enter_currency_code_error_message });
                    return false;
                }
                break;
            default:
                if (dataItem.liveKeyID == undefined || dataItem.liveKeyID == "") {
                    ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_enter_live_key_id_error_message });
                    return false;
                }
                if (dataItem.currencyCode == undefined || dataItem.currencyCode == "") {
                    ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_enter_currency_code_error_message });
                    return false;
                }
                break;
        }

        return true;
    };


    const handleSubmit = async () => {
        if (!isValid()) return;

        let imageUrl = dataItem.brandingLogo;
        if (imageFiles?.size > 0) {
            let resUrl = await API.uploadImage(imageFiles);
            if (!resUrl.success) {
                ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: `${lang.upload_fail_error_message}` });
                return;
            }
            imageUrl = resUrl.data;
            dataItem.ImageUrl = imageUrl;
        }

        const getFinalData = (paymentType) => {
            switch (paymentType) {
                case PAYMENT_TYPE.AppleSubscription:
                    break;
                default:
                    return {
                        locale: dataItem.locale,
                        liveKeyID: dataItem.liveKeyID,
                        liveSecretKey: dataItem.liveSecretKey,
                        sandboxKeyID: dataItem?.isSandboxMode ? dataItem.sandboxKeyID : null,
                        sandboxSecretKey: dataItem?.isSandboxMode ? dataItem.sandboxSecretKey : null,
                        currencyCode: dataItem.currencyCode,
                        paymentGatewayUrl: dataItem.paymentGatewayUrl,
                        successUrl: dataItem.successUrl,
                        failureUrl: dataItem.failureUrl,
                        countryCode: dataItem.countryCode,
                        isSandboxMode: dataItem.isSandboxMode ?? false,
                    }


            }

        }
        const saveData = {
            _id: dataItem._id,
            SID: dataItem?.Name?.SID,
            Name: dataItem?.Name?.Description,
            locale: dataItem.locale,
            brandingName: dataItem.brandingName,
            brandingLogo: imageUrl,
            brandingColor: dataItem.brandingColor,
            message: dataItem.message ?? "",
            OS: dataItem?.OS?.length > 0 ? dataItem.OS.map((x) => x._id) : [],
            isActive: dataItem.isActive ?? false,
            Archive: dataItem.Archive ?? false,
            ...getFinalData(dataItem?.Name?.SID)
        }
        console.log(saveData);
        const res = await API.savePaymentProvider(saveData);
        if (res.success) {
            let logData = { event: res.message == "updated" ? LOGEVENT.UPDATE_PAYMENT_PROVIDER : LOGEVENT.INSERT_PAYMENT_PROVIDER, module: MODULE.PAYMENT_PROVIDER, data: res.data, message: res.message };
            API.SaveLogs(logData);
            props.cancelEdit();
            props.refresh();
            utility.deleteLocalStorageItem(ENTITYNAME.PaymentProvider);
        } else {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res.message });
        }
    }

    const handleSelectedImage = (dataList) => {
        setImageFiles(null);
        setDataItem({ ...dataItem, brandingLogo: dataList[0].ImageUrl });
    };

    const isAppleSubscription = dataItem?.Name?.SID === PAYMENT_TYPE.AppleSubscription;

    return (
        <BossDialog
            title={props.item.Name ?? lang.create_payment_provider_dialog_header}
            onClose={props.cancelEdit}
            width={"800px"}
        >
            <div className="d-flex justify-content-between align-items-center w-100">
                <EditPageHeader title="" onSubmit={handleSubmit} onCancel={props.cancelEdit} showTitle={false} />
                {!isAppleSubscription && (
                    <div className="d-flex align-items-center flex-shrink-0" style={{ whiteSpace: "nowrap" }}>
                        <Switch
                            name="isSandboxMode"
                            label=""
                            onChange={(e) => onChange(e)}
                            checked={dataItem?.isSandboxMode}
                            value={dataItem?.isSandboxMode}
                            size="medium"
                        />
                        <span
                            className={dataItem?.isSandboxMode ? "text-success ms-2" : "text-danger ms-2"}
                            style={{ whiteSpace: "nowrap" }}
                        >
                            {lang.sandbox_mode_label}
                        </span>
                    </div>
                )}
            </div>
            <div className='row mt-2'>
                <div className='col-12'>
                    <div className='row mt-2'>
                        <div className='col-6'>
                            <label>{lang.name_label} *</label>
                            <DropDownList
                                data={paymentTypes}
                                name='Name'
                                dataItemKey='SID'
                                textField='Description'
                                className='bg-white'
                                value={dataItem.Name}
                                onChange={onChange}
                            />
                        </div>
                        <div className='col-6'>
                            <label>{lang.locale_label}</label>
                            <input
                                name={"locale"}
                                type="text"
                                maxLength="10"
                                className="form-control form-control-sm"
                                onChange={onChange}
                                value={dataItem.locale}
                            />
                        </div>
                    </div>
                    {isAppleSubscription ? (
                        <>
                            <div className="row mt-2">
                                <div className="col-6">
                                    <label htmlFor="TabView">{lang.os_label} *</label><br />
                                    <MyMultiSelect
                                        style={{ backgroundColor: "white" }}
                                        data={os}
                                        name="OS"
                                        textField="Description"
                                        dataItemKey="_id"
                                        value={dataItem.OS}
                                        onChange={onChange}
                                    />
                                </div>
                                <div className='col-6'>
                                    <label>{lang.branding_name_label} *</label>
                                    <input
                                        name="brandingName"
                                        type="text"
                                        className="form-control form-control-sm"
                                        onChange={onChange}
                                        value={dataItem.brandingName}
                                    />
                                </div>
                            </div>
                            <div className="row mt-2">
                                <div className='col-6'>
                                    <label>{lang.branding_logo_label} *</label>
                                    <ImageBrowser wherestatement={["OttPosterTypeSID", "=", OTT_POSTER_TYPE.Logo]} name={'brandingLogo'} value={dataItem.brandingLogo} onChange={onChange} setSelectedImage={handleSelectedImage} />
                                </div>
                                {/* show logo */}
                                <div className='col-1'>
                                    <img src={dataItem.brandingLogo} style={{ marginTop: '10px' }} width="40px" />
                                </div>
                                <div className='col' style={{ marginLeft: "150px", marginTop: '5px' }}>
                                    <label>{lang.branding_color_label}</label>
                                    <input
                                        name={"brandingColor"}
                                        style={{ width: "50px" }}
                                        type="color"
                                        className="form-control form-control-sm"
                                        onChange={onChange}
                                        value={dataItem.brandingColor}
                                    />
                                </div>
                            </div>
                            <div className="row mt-2">
                                <div className='col-12'>
                                    <label>{lang.message_label}</label>
                                    <textarea
                                        name={"message"}
                                        type="input"
                                        className="form-control form-control-sm"
                                        onChange={onChange}
                                        value={dataItem.message}
                                    />
                                </div>
                            </div>
                            <div className='row mt-3'>
                                <div className='col-2 mt-2'>
                                    <input
                                        style={{ border: "1px solid grey" }}
                                        name={"Archive"}
                                        type='checkbox'
                                        onChange={onChange}
                                    />
                                    <label className="ml-2">{lang.archive}</label>
                                </div>
                                <div className="col-3">
                                    <Switch
                                        name="isActive"
                                        label={lang.status_label}
                                        onChange={(e) => onChange(e)}
                                        checked={dataItem?.isActive}
                                        value={dataItem?.isActive}
                                        size={"medium"}
                                    />
                                    <label className={dataItem.isActive ? "pl-1 text-success" : "pl-1 text-danger"}>{lang.active_label}</label>
                                </div>
                            </div>
                        </>
                    )
                        : (
                            <>
                                {dataItem?.isSandboxMode == true &&
                                    <div className="row mt-2">
                                        <div className='col-6'>
                                            <label>{lang.sand_box_key_id_label} *</label>
                                            <input
                                                name={"sandboxKeyID"}
                                                type="text"
                                                className="form-control form-control-sm"
                                                onChange={onChange}
                                                value={dataItem.sandboxKeyID}
                                            />
                                        </div>
                                        <div className='col-6'>
                                            <label>{lang.sand_box_secret_key_label} *</label>
                                            <input
                                                name={"sandboxSecretKey"}
                                                type="password"
                                                className="form-control form-control-sm"
                                                onChange={onChange}
                                                value={dataItem.sandboxSecretKey}
                                            />
                                        </div>
                                    </div>
                                }
                                <div className="row mt-2">
                                    <div className='col-6'>
                                        <label>{lang.live_key_id_label} *</label>
                                        <input
                                            name={"liveKeyID"}
                                            type="text"
                                            className="form-control form-control-sm"
                                            onChange={onChange}
                                            value={dataItem.liveKeyID}
                                        />
                                    </div>
                                    <div className='col-6'>
                                        <label>{lang.live_secret_key_label} *</label>
                                        <input
                                            name={"liveSecretKey"}
                                            type="password"
                                            className="form-control form-control-sm"
                                            onChange={onChange}
                                            value={dataItem.liveSecretKey}
                                        />
                                    </div>
                                </div>
                                <div className="row mt-2">
                                    <div className="col-6">
                                        <label htmlFor="TabView">{lang.os_label} *</label><br />
                                        <MyMultiSelect
                                            style={{ backgroundColor: "white" }}
                                            data={os}
                                            name="OS"
                                            textField="Description"
                                            dataItemKey="_id"
                                            value={dataItem.OS}
                                            onChange={onChange}
                                        />
                                    </div>
                                    <div className='col-6'>
                                        <label>{lang.branding_name_label} *</label>
                                        <input
                                            name={"brandingName"}
                                            type="text"
                                            className="form-control form-control-sm"
                                            onChange={onChange}
                                            value={dataItem.brandingName}
                                        />
                                    </div>
                                </div>
                                <div className="row mt-2">
                                    <div className='col-6'>
                                        <label>{lang.branding_logo_label} *</label>
                                        <ImageBrowser wherestatement={["OttPosterTypeSID", "=", OTT_POSTER_TYPE.Logo]} name={'brandingLogo'} value={dataItem.brandingLogo} onChange={onChange} setSelectedImage={handleSelectedImage} />
                                    </div>
                                    {/* show logo */}
                                    <div className='col-1'>
                                        <img src={dataItem.brandingLogo} style={{ marginTop: '10px' }} width="40px" />
                                    </div>
                                    <div className='col' style={{ marginLeft: "150px", marginTop: '5px' }}>
                                        <label>{lang.branding_color_label}</label>
                                        <input
                                            name={"brandingColor"}
                                            style={{ width: "50px" }}
                                            type="color"
                                            className="form-control form-control-sm"
                                            onChange={onChange}
                                            value={dataItem.brandingColor}
                                        />
                                    </div>
                                </div>
                                <div className="row mt-2">
                                    <div className='col-6'>
                                        <label>{lang.currency_code_label} *</label>
                                        <input
                                            name={"currencyCode"}
                                            type="text"
                                            className="form-control form-control-sm"
                                            onChange={onChange}
                                            value={dataItem.currencyCode}
                                        />
                                    </div>
                                    <div className='col-6'>
                                        <label>{lang.country_code_label} *</label>
                                        <input
                                            name={"countryCode"}
                                            type="text"
                                            className="form-control form-control-sm"
                                            onChange={onChange}
                                            value={dataItem.countryCode}
                                        />
                                    </div>
                                </div>
                                <div className="row mt-2">
                                    <div className='col-12'>
                                        <label>{lang.payment_gateway_url_label} *</label>
                                        <input
                                            name={"paymentGatewayUrl"}
                                            type="text"
                                            className="form-control form-control-sm"
                                            onChange={onChange}
                                            value={dataItem.paymentGatewayUrl}
                                        />
                                    </div>
                                </div>
                                <div className="row mt-1">
                                    <div className='col-6'>
                                        <label>{lang.success_url_label} *</label>
                                        <input
                                            name={"successUrl"}
                                            type="text"
                                            className="form-control form-control-sm"
                                            onChange={onChange}
                                            value={dataItem.successUrl}
                                        />
                                    </div>
                                    <div className='col-6'>
                                        <label>{lang.failure_url_label} *</label>
                                        <input
                                            name={"failureUrl"}
                                            type="text"
                                            className="form-control form-control-sm"
                                            onChange={onChange}
                                            value={dataItem.failureUrl}
                                        />
                                    </div>
                                </div>
                                <div className="row mt-2">
                                    <div className='col-12'>
                                        <label>{lang.message_label}</label>
                                        <textarea
                                            name={"message"}
                                            type="input"
                                            className="form-control form-control-sm"
                                            onChange={onChange}
                                            value={dataItem.message}
                                        />
                                    </div>
                                </div>
                                <div className='row mt-3'>
                                    <div className='col-2 mt-2'>
                                        <input
                                            style={{ border: "1px solid grey" }}
                                            name={"Archive"}
                                            type='checkbox'
                                            onChange={onChange}
                                        />
                                        <label className="ml-2">{lang.archive}</label>
                                    </div>
                                    <div className="col-3">
                                        <Switch
                                            name="isActive"
                                            label={lang.status_label}
                                            onChange={(e) => onChange(e)}
                                            checked={dataItem?.isActive}
                                            value={dataItem?.isActive}
                                            size={"medium"}
                                        />
                                        <label className={dataItem.isActive ? "pl-1 text-success" : "pl-1 text-danger"}>{lang.active_label}</label>
                                    </div>
                                </div>
                            </>
                        )}
                </div>
            </div>
        </BossDialog>
    );

}

export default PaymentProviderEditForm;